import styled, { css } from "styled-components";

export const ColumnTitle = styled.p`
	font-size: 1rem;
	font-weight: bold;
	margin: 0 0 0.2rem 0;
`;
export const InputGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
	margin: 10px 0 20px;
`;

export const AreaButton = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 20px;
	margin-top: 25px;

	button {
		margin: 0;
	}

	@media (max-width: 600px) {
		flex-direction: column;

		button {
			max-width: 100%;
		}
	}
`;

interface ITextScreenProps {
	$isDisabled?: boolean;
}
export const TextScreen = styled.span<ITextScreenProps>`
	color: #7e7e7e;
	font-weight: bold;
	font-size: 0.8125rem;
	text-align: left;

	word-break: break-word;

	${({ $isDisabled }) =>
		$isDisabled &&
		css`
			color: #d3d3d3;
		`};
`;

export const LabelVolume = styled.p`
	font-size: 1rem;
	font-weight: bold;
	margin: 0;

	span {
		font-weight: normal;
	}
`;

export const BoxTable = styled.div`
	margin: 10px 0 20px;
`;

export const AreaHollow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;

	/* div checkbox */
	> div:first-child {
		> .MuiFormControl-root {
			margin: 0.3rem 0 0 0;
		}
	}
`;

export const AreaSelectSameException = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
`;
